export enum EDomainClass {
  Aircraft = 'Aircraft',
  AircraftCleaning = 'AircraftCleaning',
  AircraftConfiguration = 'AircraftConfiguration',
  AircraftConfigurationAvailability = 'AircraftConfigurationAvailability',
  AircraftConfigurationInstallation = 'AircraftConfigurationInstallation',
  AircraftMonthlyFee = 'AircraftMonthlyFee',
  AircraftMonthlyStatement = 'AircraftMonthlyStatement',
  AircraftRate = 'AircraftRate',
  AircraftType = 'AircraftType',
  AircraftTypePhoto = 'AircraftTypePhoto',
  Airport = 'Airport',
  AirportCostEstimate = 'AirportCostEstimate',
  AirportFuelPriceWeekly = 'AirportFuelPriceWeekly',
  BaseLocation = 'BaseLocation',
  CarRefueling = 'CarRefueling',
  Country = 'Country',
  CrewCompositionRule = 'CrewCompositionRule',
  CrewCompositionSettings = 'CrewCompositionSettings',
  CrewDailyAllowance = 'CrewDailyAllowance',
  CrewDailyAllowanceTable = 'CrewDailyAllowanceTable',
  CrewMealShare = 'CrewMealShare',
  CrewSeating = 'CrewSeating',
  DataMigration = 'DataMigration',
  DigitalFile = 'DigitalFile',
  DigitalFileExact = 'DigitalFileExact',
  Entity = 'Entity',
  Expense = 'Expense',
  ExpenseCategory = 'ExpenseCategory',
  ExpenseCategoryConfiguration = 'ExpenseCategoryConfiguration',
  ExpenseDraft = 'ExpenseDraft',
  ExpenseItem = 'ExpenseItem',
  Flight = 'Flight',
  FlightShare = 'FlightShare',
  GroundEvent = 'GroundEvent',
  HotelStay = 'HotelStay',
  MemberRate = 'MemberRate',
  Membership = 'Membership',
  MembershipSubscription = 'MembershipSubscription',
  MembershipSubscriptionAssociatedMember = 'MembershipSubscriptionAssociatedMember',
  MembershipSubscriptionFile = 'MembershipSubscriptionFile',
  MenuItem = 'MenuItem',
  Mission = 'Mission',
  MissionForfait = 'MissionForfait',
  MissionHolderChoice = 'MissionHolderChoice',
  MonthlyExperience = 'MonthlyExperience',
  MonthlyExperienceByAircraftType = 'MonthlyExperienceByAircraftType',
  Organisation = 'Organisation',
  ParticipationOperation = 'ParticipationOperation',
  ParticipationOperationLine = 'ParticipationOperationLine',
  ParticipationOperationReinvoice = 'ParticipationOperationReinvoice',
  PerformanceStep = 'PerformanceStep',
  Person = 'Person',
  PilotQualification = 'PilotQualification',
  PushDevice = 'PushDevice',
  Refueling = 'Refueling',
  Role = 'Role',
  Runway = 'Runway',
  Timer = 'Timer',
  TimerIndex = 'TimerIndex',
  User = 'User',
  UserAgendaAircraftPreference = 'UserAgendaAircraftPreference',
  UserResetPassword = 'UserResetPassword',
  UserRole = 'UserRole',
  AccountMouvement = 'AccountMouvement',
  AccountMouvementDocument = 'AccountMouvementDocument',
  AccountMouvementFiscalDocument = 'AccountMouvementFiscalDocument',
  AccountMouvementPayment = 'AccountMouvementPayment',
  AircraftOwnerInvoice = 'AircraftOwnerInvoice',
  AircraftOwnerInvoiceItem = 'AircraftOwnerInvoiceItem',
  CountryInternalFlightVATRate = 'CountryInternalFlightVATRate',
  DayMissionInvoiceItem = 'DayMissionInvoiceItem',
  DirectPosting = 'DirectPosting',
  FixedFeeShareCreditInvoiceItem = 'FixedFeeShareCreditInvoiceItem',
  FixedFeeShareInvoiceItem = 'FixedFeeShareInvoiceItem',
  FlightMissionInvoiceItem = 'FlightMissionInvoiceItem',
  FlightRefuelingDistribution = 'FlightRefuelingDistribution',
  FuelConsumptionDistribution = 'FuelConsumptionDistribution',
  FuelCostReference = 'FuelCostReference',
  FuelDifferenceComputationDetail = 'FuelDifferenceComputationDetail',
  Instalment = 'Instalment',
  IntermediaryAgencyPaymentCollection = 'IntermediaryAgencyPaymentCollection',
  Invoice = 'Invoice',
  InvoiceCustomerTransfer = 'InvoiceCustomerTransfer',
  InvoiceItem = 'InvoiceItem',
  Loan = 'Loan',
  LoanMovement = 'LoanMovement',
  MembershipSubscriptionAircraftMonthlyFee = 'MembershipSubscriptionAircraftMonthlyFee',
  MissionBillingInstruction = 'MissionBillingInstruction',
  MissionDepositDetail = 'MissionDepositDetail',
  MissionInvoice = 'MissionInvoice',
  MissionInvoiceItem = 'MissionInvoiceItem',
  MonthlyFeeDeductionDepositInvoiceItem = 'MonthlyFeeDeductionDepositInvoiceItem',
  MonthlyFeeDepositInvoiceItem = 'MonthlyFeeDepositInvoiceItem',
  PaymentCondition = 'PaymentCondition',
  PersonalExpenseAccountMouvementDocument = 'PersonalExpenseAccountMouvementDocument',
  StopRegularizationDetail = 'StopRegularizationDetail',
  StopRegularizationInvoiceItem = 'StopRegularizationInvoiceItem',
  WagePayment = 'WagePayment',
  InvoiceDispute = 'InvoiceDispute',
  InvoiceDisputeSettings = 'InvoiceDisputeSettings',
  InvoiceDisputeTransition = 'InvoiceDisputeTransition',
  AirportInvoiceRule = 'AirportInvoiceRule',
  ExpectedInvoiceWaiver = 'ExpectedInvoiceWaiver',
  SupplierInvoiceProvision = 'SupplierInvoiceProvision',
  PaymentReminder = 'PaymentReminder',
  PaymentReminderItem = 'PaymentReminderItem',
  PaymentReminderSettings = 'PaymentReminderSettings',
  AccountingChartsAccount = 'AccountingChartsAccount',
  AipSnapshot = 'AipSnapshot',
  CrewAnalyticsAverage = 'CrewAnalyticsAverage',
  CrewAnalyticsCategory = 'CrewAnalyticsCategory',
  CategoryDutyAnalytics = 'CategoryDutyAnalytics',
  CrewDutyAnalytics = 'CrewDutyAnalytics',
  DutyAnalytics = 'DutyAnalytics',
  DutyAnalyticsCategory = 'DutyAnalyticsCategory',
  AssetResource = 'AssetResource',
  AssetResourceAssignment = 'AssetResourceAssignment',
  AssetResourceRemark = 'AssetResourceRemark',
  CarOdometerReport = 'CarOdometerReport',
  CarResource = 'CarResource',
  CarResourceAssignment = 'CarResourceAssignment',
  CarTripReport = 'CarTripReport',
  FuelCardResource = 'FuelCardResource',
  ITResource = 'ITResource',
  SIMCardResource = 'SIMCardResource',
  ImpersonationAuditLog = 'ImpersonationAuditLog',
  PinCodeLockout = 'PinCodeLockout',
  UserInvitation = 'UserInvitation',
  UserInvitationLinkedShareholder = 'UserInvitationLinkedShareholder',
  UserInvitationRole = 'UserInvitationRole',
  UserSignupRequest = 'UserSignupRequest',
  UserSignupRequestLinkedShareholder = 'UserSignupRequestLinkedShareholder',
  CrewDailyRevenue = 'CrewDailyRevenue',
  CrewMonthlyStatement = 'CrewMonthlyStatement',
  DispatchAlertDismissal = 'DispatchAlertDismissal',
  DispatchMemberNote = 'DispatchMemberNote',
  FlightServiceStatus = 'FlightServiceStatus',
  QuickReplyTemplate = 'QuickReplyTemplate',
  ServiceProvider = 'ServiceProvider',
  ServiceRequest = 'ServiceRequest',
  ServiceRequestDocument = 'ServiceRequestDocument',
  ServiceRequestLog = 'ServiceRequestLog',
  ServiceRequestOutbox = 'ServiceRequestOutbox',
  ServiceRequestPerson = 'ServiceRequestPerson',
  ServiceType = 'ServiceType',
  FlightChecklist = 'FlightChecklist',
  FlightChecklistItem = 'FlightChecklistItem',
  FlightChecklistItemTodo = 'FlightChecklistItemTodo',
  OpsChecklistTemplate = 'OpsChecklistTemplate',
  OpsChecklistTemplateItem = 'OpsChecklistTemplateItem',
  CrewRequest = 'CrewRequest',
  CrewRequestAlias = 'CrewRequestAlias',
  EburyLoginBlock = 'EburyLoginBlock',
  EburyPayment = 'EburyPayment',
  EburyTrade = 'EburyTrade',
  ExactJournalStatus = 'ExactJournalStatus',
  ExactSync = 'ExactSync',
  ExactSyncQueue = 'ExactSyncQueue',
  ExactVATCode = 'ExactVATCode',
  UserExactToken = 'UserExactToken',
  ExactVATCodeExactLink = 'ExactVATCodeExactLink',
  ExpenseCategoryExactLink = 'ExpenseCategoryExactLink',
  ExpenseItemExactLink = 'ExpenseItemExactLink',
  FiscalDocumentExactLink = 'FiscalDocumentExactLink',
  InvoiceItemExactLink = 'InvoiceItemExactLink',
  PersonalFile = 'PersonalFile',
  PersonalFileDownload = 'PersonalFileDownload',
  PersonalFileLink = 'PersonalFileLink',
  AirportProvider = 'AirportProvider',
  AirportProviderLink = 'AirportProviderLink',
  BelgianDepartingFlightTaxesExpense = 'BelgianDepartingFlightTaxesExpense',
  BelgianDepartingFlightTaxesExpenseItem = 'BelgianDepartingFlightTaxesExpenseItem',
  CharleroiMovement = 'CharleroiMovement',
  DeclarationAlertStatus = 'DeclarationAlertStatus',
  FriendlyWebRecord = 'FriendlyWebRecord',
  GeneralDeclarationBelgiumLog = 'GeneralDeclarationBelgiumLog',
  GeneralDeclarationSnapshot = 'GeneralDeclarationSnapshot',
  ItalianFlightTaxesExpense = 'ItalianFlightTaxesExpense',
  ItalianFlightTaxesExpenseItem = 'ItalianFlightTaxesExpenseItem',
  MissionPositioning = 'MissionPositioning',
  Passenger = 'Passenger',
  PassengerAssignment = 'PassengerAssignment',
  PassengerGroup = 'PassengerGroup',
  PassengerSklAlias = 'PassengerSklAlias',
  PassengerTravelDocument = 'PassengerTravelDocument',
  SkylegsFlightDocument = 'SkylegsFlightDocument',
  SkylegsFlightService = 'SkylegsFlightService',
  TravelDocumentScan = 'TravelDocumentScan',
  FlightOfpLink = 'FlightOfpLink',
  PFFFlight = 'PFFFlight',
  PreflightOfp = 'PreflightOfp',
  FuelPriceEntry = 'FuelPriceEntry',
  FuelPriceImport = 'FuelPriceImport',
  Hotel = 'Hotel',
  HotelBooking = 'HotelBooking',
  HotelBookingAssignment = 'HotelBookingAssignment',
  HotelBookingMean = 'HotelBookingMean',
  HotelBookingMeanMail = 'HotelBookingMeanMail',
  HotelBookingMeanThirdParty = 'HotelBookingMeanThirdParty',
  HotelBookingMeanWebsite = 'HotelBookingMeanWebsite',
  HotelRating = 'HotelRating',
  AssetAcquisitionAgreement = 'AssetAcquisitionAgreement',
  AssetAcquisitionAgreementItem = 'AssetAcquisitionAgreementItem',
  AssetAcquisitionAgreementTerms = 'AssetAcquisitionAgreementTerms',
  AssetAcquisitionDeductionLine = 'AssetAcquisitionDeductionLine',
  CrewWageCar = 'CrewWageCar',
  CrewWageCarAssignment = 'CrewWageCarAssignment',
  CrewWageCarDistributedCost = 'CrewWageCarDistributedCost',
  CrewWageCarManualCost = 'CrewWageCarManualCost',
  EmploymentContract = 'EmploymentContract',
  EmploymentContractAmendment = 'EmploymentContractAmendment',
  LeaveAssignment = 'LeaveAssignment',
  LeaveAssignmentRequest = 'LeaveAssignmentRequest',
  LeaveAssignmentTemplate = 'LeaveAssignmentTemplate',
  LeaveRequest = 'LeaveRequest',
  LeaveRequestDay = 'LeaveRequestDay',
  LeaveType = 'LeaveType',
  PublicHoliday = 'PublicHoliday',
  PublicHolidayLeave = 'PublicHolidayLeave',
  RosterAggregate = 'RosterAggregate',
  RosterCategory = 'RosterCategory',
  RosterCategoryWarning = 'RosterCategoryWarning',
  RosterChangeUserAgenda = 'RosterChangeUserAgenda',
  RosterDay = 'RosterDay',
  RosterLeaveUserAgenda = 'RosterLeaveUserAgenda',
  RosterManualChangeAction = 'RosterManualChangeAction',
  RosterMonthlyStatistic = 'RosterMonthlyStatistic',
  RosterTemplate = 'RosterTemplate',
  RosterTemplateAssignment = 'RosterTemplateAssignment',
  RosterTemplateDayPosition = 'RosterTemplateDayPosition',
  RosterTemplateUserAgenda = 'RosterTemplateUserAgenda',
  RosterUserAgenda = 'RosterUserAgenda',
  RosterVolunteerDay = 'RosterVolunteerDay',
  VolunteerCall = 'VolunteerCall',
  VolunteerCallDay = 'VolunteerCallDay',
  VolunteerCallInvitation = 'VolunteerCallInvitation',
  VolunteerCallInvitationDay = 'VolunteerCallInvitationDay',
  VolunteerWeeklyReport = 'VolunteerWeeklyReport',
  AircraftTypeCrewRate = 'AircraftTypeCrewRate',
  CrewAssignment = 'CrewAssignment',
  CrewCategory = 'CrewCategory',
  CrewCategoryRate = 'CrewCategoryRate',
  CrewRate = 'CrewRate',
  CrewType = 'CrewType',
  CrewWage = 'CrewWage',
  Indexation = 'Indexation',
  OffDayPremiumLine = 'OffDayPremiumLine',
  MemberQuotaAlert = 'MemberQuotaAlert',
  MemberQuotaSettings = 'MemberQuotaSettings',
  LegalTermsVersion = 'LegalTermsVersion',
  MailboxAccount = 'MailboxAccount',
  Campaign = 'Campaign',
  CampaignContent = 'CampaignContent',
  CampaignCriteria = 'CampaignCriteria',
  CampaignFile = 'CampaignFile',
  CampaignFolder = 'CampaignFolder',
  CampaignLink = 'CampaignLink',
  CampaignRecipient = 'CampaignRecipient',
  CampaignRecipientEvent = 'CampaignRecipientEvent',
  EmailRecipient = 'EmailRecipient',
  MailSenderIdentity = 'MailSenderIdentity',
  MailSuppression = 'MailSuppression',
  MemberCommunicationPreference = 'MemberCommunicationPreference',
  PublishedMailingImage = 'PublishedMailingImage',
  MdmAuditLog = 'MdmAuditLog',
  MediaAsset = 'MediaAsset',
  MediaFolder = 'MediaFolder',
  BankAccountStatement = 'BankAccountStatement',
  CreditCardMonthlyStatement = 'CreditCardMonthlyStatement',
  CreditCardStatementLine = 'CreditCardStatementLine',
  ExternalMonthlyStatement = 'ExternalMonthlyStatement',
  MonthlyStatement = 'MonthlyStatement',
  PersonalExpenseMonthlyStatement = 'PersonalExpenseMonthlyStatement',
  MyHandlingFbo = 'MyHandlingFbo',
  MyHandlingOrphanRequest = 'MyHandlingOrphanRequest',
  MyHandlingSyncState = 'MyHandlingSyncState',
  PersistedEboxMessage = 'PersistedEboxMessage',
  PersistedEboxMessageAttachment = 'PersistedEboxMessageAttachment',
  BankAccountPayment = 'BankAccountPayment',
  BankAccountTransferFileRequest = 'BankAccountTransferFileRequest',
  CashPayment = 'CashPayment',
  CreditCardPayment = 'CreditCardPayment',
  ExactPayment = 'ExactPayment',
  ExactSettlementPayment = 'ExactSettlementPayment',
  IntermediaryAgencyPayment = 'IntermediaryAgencyPayment',
  InternalPayment = 'InternalPayment',
  Payment = 'Payment',
  PersonalExpenseMonthlyStatementPayment = 'PersonalExpenseMonthlyStatementPayment',
  PersonalExpensePayment = 'PersonalExpensePayment',
  BankAccount = 'BankAccount',
  BankAccountAuthorizedEntity = 'BankAccountAuthorizedEntity',
  CreditCard = 'CreditCard',
  Domiciliation = 'Domiciliation',
  PaymentMean = 'PaymentMean',
  PeppolInboxDocument = 'PeppolInboxDocument',
  PeppolInboxDocumentItem = 'PeppolInboxDocumentItem',
  PeppolSync = 'PeppolSync',
  PeppolSyncQueue = 'PeppolSyncQueue',
  PontoAccount = 'PontoAccount',
  PontoInstitution = 'PontoInstitution',
  PontoMatchProposal = 'PontoMatchProposal',
  PontoSettings = 'PontoSettings',
  PontoSynchronization = 'PontoSynchronization',
  PontoTransaction = 'PontoTransaction',
  ReconciliationRule = 'ReconciliationRule',
  LabelSetting = 'LabelSetting',
  QuoteCalculationSupport = 'QuoteCalculationSupport',
  QuoteDay = 'QuoteDay',
  QuoteFlight = 'QuoteFlight',
  QuoteFlightConfiguration = 'QuoteFlightConfiguration',
  QuoteFuelConsumptionCalculationSupport = 'QuoteFuelConsumptionCalculationSupport',
  QuoteFuelPriceCalculationSupport = 'QuoteFuelPriceCalculationSupport',
  QuoteHandlingFeesCalculationSupport = 'QuoteHandlingFeesCalculationSupport',
  QuoteMission = 'QuoteMission',
  QuoteMissionConfiguration = 'QuoteMissionConfiguration',
  QuotePassenger = 'QuotePassenger',
  QuotePositioningSupport = 'QuotePositioningSupport',
  QuoteRateCalculationSupport = 'QuoteRateCalculationSupport',
  RefuelEuAirport = 'RefuelEuAirport',
  RefuelEuAirportSnapshot = 'RefuelEuAirportSnapshot',
  RefuelEuExemption = 'RefuelEuExemption',
  RefuelEuFlightException = 'RefuelEuFlightException',
  RefuelEuFlightSnapshot = 'RefuelEuFlightSnapshot',
  RefuelEuFuelMapping = 'RefuelEuFuelMapping',
  RefuelEuNotificationConfig = 'RefuelEuNotificationConfig',
  RefuelEuOfpDivergence = 'RefuelEuOfpDivergence',
  RefuelEuPlannedOfp = 'RefuelEuPlannedOfp',
  RefuelEuReferencePrice = 'RefuelEuReferencePrice',
  RefuelEuSafSupply = 'RefuelEuSafSupply',
  UserLinkedShareholder = 'UserLinkedShareholder',
  UserShareholderJoinRequest = 'UserShareholderJoinRequest',
  SkylegsSync = 'SkylegsSync',
  SkylegsSyncQueue = 'SkylegsSyncQueue',
  SkylegsWebhookSubscription = 'SkylegsWebhookSubscription',
  StockAllocation = 'StockAllocation',
  StockInventoryCount = 'StockInventoryCount',
  StockInventoryCountLine = 'StockInventoryCountLine',
  StockInventorySheet = 'StockInventorySheet',
  StockInventorySheetLine = 'StockInventorySheetLine',
  StockIssueExpense = 'StockIssueExpense',
  StockLedgerLock = 'StockLedgerLock',
  StockLot = 'StockLot',
  StockMovement = 'StockMovement',
  StockProduct = 'StockProduct',
  StockReceipt = 'StockReceipt',
  DailyTimesheetState = 'DailyTimesheetState',
  TimeClockLock = 'TimeClockLock',
  TimeDeclaration = 'TimeDeclaration',
  TimeEvent = 'TimeEvent',
  TimeKioskDevice = 'TimeKioskDevice',
  TimeOriginRefusal = 'TimeOriginRefusal',
  TimeRuleSet = 'TimeRuleSet',
  TimesheetEnrollment = 'TimesheetEnrollment',
  TimesheetMonth = 'TimesheetMonth',
  TimesheetMonthAudit = 'TimesheetMonthAudit',
  UserAgenda = 'UserAgenda',
  UserAgendaEvent = 'UserAgendaEvent',
  UserAgendaFlightEvent = 'UserAgendaFlightEvent',
  UserAgendaGroundCourseEvent = 'UserAgendaGroundCourseEvent',
  UserAgendaOfficeDutyEvent = 'UserAgendaOfficeDutyEvent',
  UserAgendaPositioningEvent = 'UserAgendaPositioningEvent',
  UserAgendaPresenceEvent = 'UserAgendaPresenceEvent',
  UserAgendaTrainingEvent = 'UserAgendaTrainingEvent',
  Audit = 'Audit',
  AuditArea = 'AuditArea',
  AuditChecklist = 'AuditChecklist',
  AuditChecklistAnswer = 'AuditChecklistAnswer',
  AuditChecklistItem = 'AuditChecklistItem',
  AuditChecklistSnapshot = 'AuditChecklistSnapshot',
  AuditCycleDefault = 'AuditCycleDefault',
  AuditFinding = 'AuditFinding',
  AuditPlan = 'AuditPlan',
  AuditPlanDeviation = 'AuditPlanDeviation',
  AuditProgramme = 'AuditProgramme',
  AuditProgrammeArea = 'AuditProgrammeArea',
  AuditProgrammeCycleExtension = 'AuditProgrammeCycleExtension',
  AuditReport = 'AuditReport',
  AuditTimelineEvent = 'AuditTimelineEvent',
  Auditor = 'Auditor',
  AuditorQualification = 'AuditorQualification',
  CamoApprovalScopeLine = 'CamoApprovalScopeLine',
  ChecklistFeedback = 'ChecklistFeedback',
  ChecklistQuestion = 'ChecklistQuestion',
  ChecklistQuestionDocLink = 'ChecklistQuestionDocLink',
  ChecklistQuestionLink = 'ChecklistQuestionLink',
  ChecklistResponseOption = 'ChecklistResponseOption',
  ChecklistResponseSet = 'ChecklistResponseSet',
  ChecklistSampling = 'ChecklistSampling',
  ChecklistSamplingEntry = 'ChecklistSamplingEntry',
  ChecklistTopic = 'ChecklistTopic',
  ComplianceAuditTrailEntry = 'ComplianceAuditTrailEntry',
  ComplianceCheckStep = 'ComplianceCheckStep',
  ComplianceFramework = 'ComplianceFramework',
  ComplianceImportBatch = 'ComplianceImportBatch',
  ComplianceObservation = 'ComplianceObservation',
  ComplianceScopeItem = 'ComplianceScopeItem',
  ComplianceSignature = 'ComplianceSignature',
  ComplianceSummaryReport = 'ComplianceSummaryReport',
  ComplianceTag = 'ComplianceTag',
  CorpusRevisionChange = 'CorpusRevisionChange',
  CorpusStalenessCheck = 'CorpusStalenessCheck',
  CorrectiveAction = 'CorrectiveAction',
  CorrectiveActionPlan = 'CorrectiveActionPlan',
  DeadlineExtension = 'DeadlineExtension',
  DocumentTocEntry = 'DocumentTocEntry',
  DocumentaryImpact = 'DocumentaryImpact',
  EasaCatalogueEntry = 'EasaCatalogueEntry',
  EffectivenessReview = 'EffectivenessReview',
  ExternalAuditEvent = 'ExternalAuditEvent',
  ExternalRequirement = 'ExternalRequirement',
  FindingSeverityScale = 'FindingSeverityScale',
  FindingStatusEntry = 'FindingStatusEntry',
  FunctionalResponsibility = 'FunctionalResponsibility',
  IngestionLog = 'IngestionLog',
  ManagementReview = 'ManagementReview',
  ManagementReviewDecision = 'ManagementReviewDecision',
  OrganisationComplianceProfile = 'OrganisationComplianceProfile',
  PendingAmendment = 'PendingAmendment',
  PendingAmendmentTopicLink = 'PendingAmendmentTopicLink',
  PlannedAudit = 'PlannedAudit',
  QuestionDocReviewEntry = 'QuestionDocReviewEntry',
  RampInspection = 'RampInspection',
  RampInspectionItem = 'RampInspectionItem',
  RecordRetentionPolicy = 'RecordRetentionPolicy',
  ReferenceCounter = 'ReferenceCounter',
  RegulatoryChangeAlert = 'RegulatoryChangeAlert',
  RegulatoryDocument = 'RegulatoryDocument',
  RegulatoryTopic = 'RegulatoryTopic',
  RegulatoryTopicVersion = 'RegulatoryTopicVersion',
  RepeatFindingLink = 'RepeatFindingLink',
  RequirementMapping = 'RequirementMapping',
  RiskLikelihoodLevel = 'RiskLikelihoodLevel',
  RiskMatrixConfiguration = 'RiskMatrixConfiguration',
  RiskSeverityLevel = 'RiskSeverityLevel',
  RiskTolerabilityBand = 'RiskTolerabilityBand',
  RootCauseAnalysis = 'RootCauseAnalysis',
  RootCauseItem = 'RootCauseItem',
  SpecificApproval = 'SpecificApproval',
  Supplier = 'Supplier',
  Abbreviation = 'Abbreviation',
  AuthorityHiddenAttachment = 'AuthorityHiddenAttachment',
  AuthorityMailFolder = 'AuthorityMailFolder',
  AuthorityMessageTracker = 'AuthorityMessageTracker',
  AuthorityThreadFolderEntry = 'AuthorityThreadFolderEntry',
  AuthorityThreadParticipant = 'AuthorityThreadParticipant',
  ChecklistChangeNote = 'ChecklistChangeNote',
  ChecklistItemAnchor = 'ChecklistItemAnchor',
  ComplianceAlert = 'ComplianceAlert',
  ComplianceChecklist = 'ComplianceChecklist',
  ComplianceChecklistItem = 'ComplianceChecklistItem',
  ComplianceLink = 'ComplianceLink',
  Definition = 'Definition',
  Design = 'Design',
  Diagram = 'Diagram',
  DiagramCategory = 'DiagramCategory',
  DiagramRevision = 'DiagramRevision',
  DocumentCategory = 'DocumentCategory',
  DocumentCategoryMembership = 'DocumentCategoryMembership',
  DocumentSubmission = 'DocumentSubmission',
  DocumentType = 'DocumentType',
  DocumentUserAssignment = 'DocumentUserAssignment',
  DocumentationMediaEntry = 'DocumentationMediaEntry',
  DocumentationMediaEntryMembership = 'DocumentationMediaEntryMembership',
  DocumentationMediaReference = 'DocumentationMediaReference',
  DocumentationSettings = 'DocumentationSettings',
  ManualDocument = 'ManualDocument',
  Page = 'Page',
  PageHeading = 'PageHeading',
  PageLabel = 'PageLabel',
  PageLabelAssignment = 'PageLabelAssignment',
  PageRevisionMetadata = 'PageRevisionMetadata',
  PageSection = 'PageSection',
  PageSectionRevisionMetadata = 'PageSectionRevisionMetadata',
  PageSectionSnapshot = 'PageSectionSnapshot',
  PageSnapshot = 'PageSnapshot',
  PageWorkflowHistory = 'PageWorkflowHistory',
  PageWorkflowState = 'PageWorkflowState',
  Revision = 'Revision',
  RevisionReminder = 'RevisionReminder',
  SharedFileLink = 'SharedFileLink',
  SharedFileLinkDownload = 'SharedFileLinkDownload',
  SmartModule = 'SmartModule',
  SupervisoryAuthority = 'SupervisoryAuthority',
  SupervisoryAuthorityContact = 'SupervisoryAuthorityContact',
  WorkflowDefinition = 'WorkflowDefinition',
  WorkflowStep = 'WorkflowStep',
  WebmanualsConnection = 'WebmanualsConnection',
  WebmanualsImportPhase = 'WebmanualsImportPhase',
  WebmanualsImportRun = 'WebmanualsImportRun',
  DocCategory = 'DocCategory',
  DocDocument = 'DocDocument',
  DocSignature = 'DocSignature',
  DocVersion = 'DocVersion',
  PostHolder = 'PostHolder',
  PostHolderAssignment = 'PostHolderAssignment',
  FlightWish = 'FlightWish',
  FlightWishMatch = 'FlightWishMatch',
  BankAccountValidationRequest = 'BankAccountValidationRequest',
  CardLineProposal = 'CardLineProposal',
  EurocontrolFlightLine = 'EurocontrolFlightLine',
  ExpenseInboxSettings = 'ExpenseInboxSettings',
  ExtractionEvalResult = 'ExtractionEvalResult',
  ExtractionEvalRun = 'ExtractionEvalRun',
  InboundDocument = 'InboundDocument',
  InboundDocumentItem = 'InboundDocumentItem',
  MerchantSupplierMapping = 'MerchantSupplierMapping',
  OcrCacheEntry = 'OcrCacheEntry',
  PipelineRuntimeState = 'PipelineRuntimeState',
  ReceiptSubmission = 'ReceiptSubmission',
  SupplierAutomationRule = 'SupplierAutomationRule',
  SupplierCategoryRule = 'SupplierCategoryRule',
  SupplierCreationRequest = 'SupplierCreationRequest',
  SupplierDateFormatRule = 'SupplierDateFormatRule',
  CrewDocumentSubmission = 'CrewDocumentSubmission',
  CrewTravelDocument = 'CrewTravelDocument',
  ExaminerCertificate = 'ExaminerCertificate',
  InstructorCertificate = 'InstructorCertificate',
  LanguageProficiency = 'LanguageProficiency',
  Licence = 'Licence',
  MedicalCertificate = 'MedicalCertificate',
  MedicalCertificateClassValidity = 'MedicalCertificateClassValidity',
  MedicalCertificateRestriction = 'MedicalCertificateRestriction',
  Rating = 'Rating',
  RatingOccurrence = 'RatingOccurrence',
  AdRequirement = 'AdRequirement',
  AdRequirementTask = 'AdRequirementTask',
  AircraftAppointment = 'AircraftAppointment',
  AircraftComponent = 'AircraftComponent',
  AircraftStatusReport = 'AircraftStatusReport',
  AirworthinessDirective = 'AirworthinessDirective',
  AogPeriod = 'AogPeriod',
  AssessmentLine = 'AssessmentLine',
  CamoManagementContract = 'CamoManagementContract',
  ComponentReplacement = 'ComponentReplacement',
  CounterReading = 'CounterReading',
  Defect = 'Defect',
  DefectNotificationState = 'DefectNotificationState',
  DirectiveApplicability = 'DirectiveApplicability',
  DirectiveCompliance = 'DirectiveCompliance',
  DirectiveNotificationState = 'DirectiveNotificationState',
  DirectiveReview = 'DirectiveReview',
  ExternalWorkPackage = 'ExternalWorkPackage',
  FleetStatusReport = 'FleetStatusReport',
  FleetStatusSnapshot = 'FleetStatusSnapshot',
  ImportBatch = 'ImportBatch',
  ImportLine = 'ImportLine',
  InstallationEvent = 'InstallationEvent',
  LifeLimit = 'LifeLimit',
  LogbookEntry = 'LogbookEntry',
  MaintenanceConfiguration = 'MaintenanceConfiguration',
  MaintenanceDocument = 'MaintenanceDocument',
  MaintenanceDocumentLink = 'MaintenanceDocumentLink',
  MaintenanceProgramme = 'MaintenanceProgramme',
  MaintenancePublication = 'MaintenancePublication',
  MaintenanceRelease = 'MaintenanceRelease',
  MaintenanceSlot = 'MaintenanceSlot',
  MaintenanceTask = 'MaintenanceTask',
  MajorAssembly = 'MajorAssembly',
  OnboardDocument = 'OnboardDocument',
  ProgrammeRevision = 'ProgrammeRevision',
  ProgrammeRevisionBasis = 'ProgrammeRevisionBasis',
  ProgrammeTemporaryRevision = 'ProgrammeTemporaryRevision',
  ProgrammeToleranceDefault = 'ProgrammeToleranceDefault',
  PublicationAssessment = 'PublicationAssessment',
  PublicationRevision = 'PublicationRevision',
  SbCategoryMapping = 'SbCategoryMapping',
  ServiceBulletin = 'ServiceBulletin',
  TaskAdjustment = 'TaskAdjustment',
  TaskApplicability = 'TaskApplicability',
  TaskCompliance = 'TaskCompliance',
  TaskNotificationState = 'TaskNotificationState',
  TaskRequirement = 'TaskRequirement',
  UsageCounter = 'UsageCounter',
  UtilisationEntry = 'UtilisationEntry',
  WeighingRecord = 'WeighingRecord',
  WorkOrder = 'WorkOrder',
  WorkOrderItem = 'WorkOrderItem',
  MdmActivationLockBypass = 'MdmActivationLockBypass',
  MdmApp = 'MdmApp',
  MdmAppCategory = 'MdmAppCategory',
  MdmAppLicense = 'MdmAppLicense',
  MdmDepProfile = 'MdmDepProfile',
  MdmDevicePackage = 'MdmDevicePackage',
  MdmDeviceProfile = 'MdmDeviceProfile',
  MdmDeviceSecret = 'MdmDeviceSecret',
  MdmDeviceSnapshot = 'MdmDeviceSnapshot',
  MdmEnrollmentHookExecution = 'MdmEnrollmentHookExecution',
  MdmPackage = 'MdmPackage',
  MdmPayload = 'MdmPayload',
  MdmProfile = 'MdmProfile',
  MdmScheduledCommand = 'MdmScheduledCommand',
  MdmSmartGroup = 'MdmSmartGroup',
  CrewAppLinkInvitation = 'CrewAppLinkInvitation',
  CrewProfileStamp = 'CrewProfileStamp',
  CrewTodo = 'CrewTodo',
  EmployeeStamp = 'EmployeeStamp',
  MobileAppLastSeen = 'MobileAppLastSeen',
  MobileFeatureFlag = 'MobileFeatureFlag',
  ProcessedMutation = 'ProcessedMutation',
  RefuelEuAirportStatus = 'RefuelEuAirportStatus',
  SyncSequence = 'SyncSequence',
  SyncTombstone = 'SyncTombstone',
  OfficeDutyProposal = 'OfficeDutyProposal',
  OptimizationReport = 'OptimizationReport',
  ProcurementContract = 'ProcurementContract',
  ProcurementContractAmendment = 'ProcurementContractAmendment',
  ProcurementContractCoveredPerson = 'ProcurementContractCoveredPerson',
  ProcurementContractDocument = 'ProcurementContractDocument',
  Prospect = 'Prospect',
  ProspectContact = 'ProspectContact',
  ProspectCrmSettings = 'ProspectCrmSettings',
  ProspectGdprConsent = 'ProspectGdprConsent',
  ProspectInteraction = 'ProspectInteraction',
  ProspectNextAction = 'ProspectNextAction',
  ProspectStageTransition = 'ProspectStageTransition',
  ProspectTask = 'ProspectTask',
  TypicalMission = 'TypicalMission',
  DossierPromptTemplate = 'DossierPromptTemplate',
  ProspectDossier = 'ProspectDossier',
  CostEstimation = 'CostEstimation',
  CostEstimationLine = 'CostEstimationLine',
  CostEstimationScenario = 'CostEstimationScenario',
  ParticipationStep = 'ParticipationStep',
  ProspectEstimationSettings = 'ProspectEstimationSettings',
  EccairsSubmission = 'EccairsSubmission',
  EccairsValueListEntry = 'EccairsValueListEntry',
  ErpEvent = 'ErpEvent',
  ErpEventDebrief = 'ErpEventDebrief',
  ErpEventParticipant = 'ErpEventParticipant',
  ExternalSafetyPublication = 'ExternalSafetyPublication',
  FlightRiskAssessment = 'FlightRiskAssessment',
  ForasFactor = 'ForasFactor',
  ForasFactorAnswer = 'ForasFactorAnswer',
  HazardTaxonomyNode = 'HazardTaxonomyNode',
  JustCultureReview = 'JustCultureReview',
  ManagementOfChange = 'ManagementOfChange',
  MandatoryOccurrenceCriterion = 'MandatoryOccurrenceCriterion',
  OccurrenceEventLink = 'OccurrenceEventLink',
  SafetyAcceptancePrinciple = 'SafetyAcceptancePrinciple',
  SafetyAction = 'SafetyAction',
  SafetyActionSignOff = 'SafetyActionSignOff',
  SafetyAssessment = 'SafetyAssessment',
  SafetyBarrier = 'SafetyBarrier',
  SafetyCausalFactor = 'SafetyCausalFactor',
  SafetyChangeApproval = 'SafetyChangeApproval',
  SafetyConfiguration = 'SafetyConfiguration',
  SafetyConsequence = 'SafetyConsequence',
  SafetyErcMatrix = 'SafetyErcMatrix',
  SafetyExternalReportingToken = 'SafetyExternalReportingToken',
  SafetyHazard = 'SafetyHazard',
  SafetyHazardSource = 'SafetyHazardSource',
  SafetyImportRun = 'SafetyImportRun',
  SafetyInvestigation = 'SafetyInvestigation',
  SafetyInvestigationClosure = 'SafetyInvestigationClosure',
  SafetyIssue = 'SafetyIssue',
  SafetyKeyPersonnel = 'SafetyKeyPersonnel',
  SafetyLikelihoodBand = 'SafetyLikelihoodBand',
  SafetyMeeting = 'SafetyMeeting',
  SafetyMeetingAttendee = 'SafetyMeetingAttendee',
  SafetyMeetingItem = 'SafetyMeetingItem',
  SafetyOccurrence = 'SafetyOccurrence',
  SafetyOccurrenceStatusEntry = 'SafetyOccurrenceStatusEntry',
  SafetyPerformanceIndicator = 'SafetyPerformanceIndicator',
  SafetyPublication = 'SafetyPublication',
  SafetyRecommendation = 'SafetyRecommendation',
  SafetyReport = 'SafetyReport',
  SafetyReporterIdentity = 'SafetyReporterIdentity',
  SafetyReview = 'SafetyReview',
  SafetyRisk = 'SafetyRisk',
  SafetyRiskAssessmentRecord = 'SafetyRiskAssessmentRecord',
  SafetySeverityDescriptor = 'SafetySeverityDescriptor',
  SafetyTag = 'SafetyTag',
  SpiObjective = 'SpiObjective',
  SpiPeriodValue = 'SpiPeriodValue',
  BlockedSender = 'BlockedSender',
  ChannelMessage = 'ChannelMessage',
  ConversationDraft = 'ConversationDraft',
  ConversationThread = 'ConversationThread',
  ConversationThreadMission = 'ConversationThreadMission',
  DispatchSettings = 'DispatchSettings',
  EmailMessage = 'EmailMessage',
  IMessageMessage = 'IMessageMessage',
  InternalNoteMessage = 'InternalNoteMessage',
  MessageAttachment = 'MessageAttachment',
  MessageReaction = 'MessageReaction',
  PhoneCallMessage = 'PhoneCallMessage',
  ThreadEvent = 'ThreadEvent',
  ThreadRecipient = 'ThreadRecipient',
  WhatsAppMessage = 'WhatsAppMessage',
  Todo = 'Todo',
  TodoCategory = 'TodoCategory',
  TodoMessage = 'TodoMessage',
  TodoRecurrence = 'TodoRecurrence',
  TodoRecurrenceTarget = 'TodoRecurrenceTarget',
  TodoTarget = 'TodoTarget',
  AerodromeRequirement = 'AerodromeRequirement',
  Qualification = 'Qualification',
  QualificationEvent = 'QualificationEvent',
  QualificationEventDocument = 'QualificationEventDocument',
  QualificationIssue = 'QualificationIssue',
  ScandlearnAccount = 'ScandlearnAccount',
  ScandlearnCertificate = 'ScandlearnCertificate',
  ScandlearnSyncRun = 'ScandlearnSyncRun',
  ScandlearnTraining = 'ScandlearnTraining',
  TrainingAttestation = 'TrainingAttestation',
  TrainingCategory = 'TrainingCategory',
  TrainingKind = 'TrainingKind',
  TrainingQualificationSet = 'TrainingQualificationSet',
  TrainingRecord = 'TrainingRecord',
  TrainingRecordDocument = 'TrainingRecordDocument',
  TrainingSession = 'TrainingSession',
  TrainingSessionAttendee = 'TrainingSessionAttendee',
  TrainingSessionDocument = 'TrainingSessionDocument',
  TrainingSessionDutyRelease = 'TrainingSessionDutyRelease',
  TrainingSessionPresence = 'TrainingSessionPresence',
  TrainingSessionSitting = 'TrainingSessionSitting',
  TrainingSetControl = 'TrainingSetControl',
  VppEventLog = 'VppEventLog',
  VppUserAssignment = 'VppUserAssignment',
  ChangeHistory = 'ChangeHistory',
}
